export default "__VITE_ASSET__94272571__"